<template>
  <div class="user-home-page">
    <userBannerEl :showAv="true" title="个人主页" enTitle="DESIGN COMPETITION"/>
    <div class="page-content">
      <div class="handle-box">
        <router-link :to="{'name':'userAccountManage'}">
          <p class="handle-item">
            <img :src="require('@/assets/user_handle_01.png')" alt="账号管理">
          </p>
        </router-link>
        <router-link :to="{'name':'userWorks'}">
          <p class="handle-item">
            <img :src="require('@/assets/user_handle_02.png')" alt="作品管理">
          </p>
        </router-link>
      </div>
      <div class="handle-logout" @click="logout()">退出登录</div>
    </div>

  </div>
</template>

<script>
import userBannerEl from "@/components/userBannerEl";
export default {
  name: "index",
  data() {
    return {}
  },
  components:{
    userBannerEl
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    logout(){
      this.$store.commit('infoModule/updateToken',"");
      this.$router.push({name: 'userLogin'});
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "~@/css/_var.scss";
  .user-home-page {
    width: 100%;
    //background: url(~@/assets/replace/contact_banner.jpeg) no-repeat center top;
    //background-size: 100%;
    .page-content {
      width: $mainWidth;
      margin: 0 auto;
      position: relative;
    }

    .handle-box {
      width: 803px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 198px 0 192px;
      .handle-item {
        width: 309px;
        cursor: pointer;
        & > img {
          display: block;
          width: 100%;
        }
      }
    }
    .handle-logout {
      display: block;
      width: 185px;
      height: 48px;
      color: #fff;
      font-size: 28px;
      position: absolute;
      bottom: 80px;
      left: 620px;
      clear: both;
      background-color: #BA0704;
      line-height: 48px;
      text-align: center;
      cursor: pointer;
    }
  }
</style>
